<template>
  <div>
    <div class="diagnose">
      <el-row>
        <h1 style="margin-top:180px;">痛风诊断</h1>
      </el-row>
    </div>
    <div class="content">
      <el-row>
          <el-col :span="18" offset=3><div class="grid-content bg-purple"><h2 class="crumb">ACR/EULAR2015痛风诊断新标准，该新标准由美国国立卫生研究院和关节炎基金会，以及ACR和EULAR联合推出。该分类标准突破了现有标准的局限性，纳入最新研究结果，旨在为临床医生和患者的诊疗提供参考。</h2></div></el-col>
      </el-row>
      <el-row style="margin-bottom: 30px;">
        <el-col :span="18" offset=3 style="border:1px solid #ccc">
          <el-checkbox-group v-model="form" size="small" class="fldys-text"  @change="formChange">
            <el-checkbox name="fulicheckbox" v-for="(item,index) in foptions" :key="index" :label="index" size='large' border>{{ item.value }}</el-checkbox>
          </el-checkbox-group>
          <el-button type="primary" :loading="bloading" @click="submit">提交</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'diagnose',
  data () {
    return {
      bloading: false,
      score: 0,
      form: [],
      foptions: [
        { value: '累及踝关节或足中段', count: 1 },
        { value: '累及第一跖趾关节', count: 2 },
        { value: '受累关节皮肤发红', count: 1 },
        { value: '受累关节触痛明显', count: 1 },
        { value: '受累关节活动障碍', count: 1 },
        { value: '一次典型发作史（反复关节痛≧2次，抗感染治疗无效，疼痛24小时内达峰，14天内症状缓解疼痛间歇期疼痛完缓解）', count: 1 },
        { value: '多次典型发作史', count: 2 },
        { value: '痛风石', count: 4 },
        { value: '血尿酸﹤4mg/dl(0.24mmol/L)', count: -4 },
        { value: '血尿酸6-8mg/dl(0.36-0.48mmol/L)', count: 2 },
        { value: '血尿酸8-10mg/dl(0.48-0.6mmol/L)', count: 3 },
        { value: '血尿酸≧10mg/dl(0.6mmol/L)', count: 4 },
        { value: '关节液尿酸盐结晶阴性', count: -2 },
        { value: '影像学检查关节B超见双轨征', count: 4 },
        { value: '双能量CT检测到尿酸盐结晶', count: 4 },
        { value: '影像学检查提示痛风相关关节损伤', count: 4 }
      ]
    }
  },
  methods: {
    formChange: function () {
      let sadd = 0
      for (var i = 0; i < this.form.length; i++) {
        var temp = this.form[i]
        sadd += this.foptions[temp].count
      }
      this.score = sadd
    },
    submit: function () {
      let msg = ''
      console.log(this.score)
      if (this.score < 5) {
        msg = '排除痛风，考虑其他诊断。'
      } else if (this.score < 8) {
        msg = '疑似痛风，若条件有限，则严密随访以明确诊断。'
      } else {
        msg = '确诊痛风，请尽快就医诊治。'
      }
      this.$alert(msg, '诊断结果', {
        confirmButtonText: '确定',
        center: 'true',
        customClass: 'message-check'
      })
    }
  }
}
</script>

<style scoped>
body {
  width: 100%;
  margin:0 0;
  padding:0 0;
}
#App {
  width: 100%;
  margin:0 0;
  padding:0 0;
}
.diagnose {
  height: 400px;
  background-size: cover;
  position: relative;
  background:url('../assets/food_bg_1.jpg');
  background-repeat: no-repeat;
  background-position: center center;
}
.diagnose h1{color:#eee;letter-spacing:12px;font-family: "微软雅黑";}
.el-checkbox__label {
  display: block;
}
.el-checkbox {
  margin-top:15px;
  margin-bottom:15px;
  height:auto;
}
.el-checkbox, .el-checkbox__input {
  white-space: normal;
}
.el-checkbox.is-bordered.el-checkbox--small {
  height:auto;
}
.el-button {
  margin-bottom:15px;
}
.mesagge-check {
  width: auto;
}
</style>
